import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

const Button = styled.button`
	display: inline-block;
	padding: ${(p) => (p.size === 'small' ? '0 1.5rem;' : '0 2rem')};
	border: none;
	border-radius: 1rem;
	font-weight: 700;
	font-size: ${(p) => (p.size === 'small' ? '0.9rem' : '1rem')};
	line-height: ${(p) => (p.size === 'small' ? '2rem' : '2.5rem')};
	text-decoration: none;
	cursor: pointer;

	color: ${(p) =>
		p.bg === 'white' || p.bg === 'grey' ? p.theme.color.dark : '#fff'};
	background-color: ${(p) => {
		if (p.bg === 'red') {
			return p.theme.color.red;
		} else if (p.bg === 'green') {
			return p.theme.color.green;
		} else if (p.bg === 'white') {
			return '#fff';
		} else if (p.bg === 'blue') {
			return p.theme.color.blue;
		} else if (p.bg === 'grey') {
			return p.theme.color.lightGrey;
		} else {
			return p.theme.color.dark;
		}
	}};
	${'' /* transition: box-shadow 0.3s;
	&:hover {
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
	} */}
`;
const ButtonA = styled.a`
	display: inline-block;
	padding: ${(p) => (p.size === 'small' ? '0 1.5rem;' : '0 2rem')};
	border: none;
	border-radius: 1rem;
	font-weight: 700;
	font-size: ${(p) => (p.size === 'small' ? '0.9rem' : '1rem')};
	line-height: ${(p) => (p.size === 'small' ? '2rem' : '2.5rem')};
	text-decoration: none;
	cursor: pointer;

	color: ${(p) =>
		p.bg === 'white' || p.bg === 'grey' ? p.theme.color.dark : '#fff'};
	background-color: ${(p) => {
		if (p.bg === 'red') {
			return p.theme.color.red;
		} else if (p.bg === 'green') {
			return p.theme.color.green;
		} else if (p.bg === 'white') {
			return '#fff';
		} else if (p.bg === 'blue') {
			return p.theme.color.blue;
		} else if (p.bg === 'grey') {
			return p.theme.color.lightGrey;
		} else {
			return p.theme.color.dark;
		}
	}};
	${'' /* transition: box-shadow 0.3s;
	&:hover {
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
	} */}
`;
const ButtonLink = styled(Link)`
	display: inline-block;
	padding: ${(p) => (p.size === 'small' ? '0 1.5rem;' : '0 2rem')};
	border: none;
	border-radius: 1rem;
	font-weight: 700;
	font-size: ${(p) => (p.size === 'small' ? '0.9rem' : '1rem')};
	line-height: ${(p) => (p.size === 'small' ? '2rem' : '2.5rem')};
	text-decoration: none;
	cursor: pointer;

	color: ${(p) =>
		p.bg === 'white' || p.bg === 'grey' ? p.theme.color.dark : '#fff'};
	background-color: ${(p) => {
		if (p.bg === 'red') {
			return p.theme.color.red;
		} else if (p.bg === 'green') {
			return p.theme.color.green;
		} else if (p.bg === 'white') {
			return '#fff';
		} else if (p.bg === 'blue') {
			return p.theme.color.blue;
		} else if (p.bg === 'grey') {
			return p.theme.color.lightGrey;
		} else {
			return p.theme.color.dark;
		}
	}};
	${'' /* transition: box-shadow 0.3s;
	&:hover {
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
	} */}
`;

export default ({ type, children, bg, size, to, href, onClick }) => {
	if (type === 'link')
		return (
			<ButtonLink to={to} bg={bg} size={size} onClick={onClick}>
				{children}
			</ButtonLink>
		);
	else if (type === 'anchor')
		return (
			<ButtonA bg={bg} href={href} size={size} onClick={onClick}>
				{children}
			</ButtonA>
		);
	else
		return (
			<Button bg={bg} size={size} onClick={onClick}>
				{children}
			</Button>
		);
};
